var gallery = {
	modal: '#gallery-modal',
	image: $('.modal-gallery-image-wrapper img'),
	content: $('.modal-gallery-content-wrapper'),
	content_inner: $('.modal-gallery-content-inner'),
	counter: $('.gallery-slide-counter'),
	prevNext_wrapper: $('.gallery-slide-nav'),
	trigger_nav: $('[data-gallery-nav]'),
	trigger_prev: $('[data-gallery-prev]'),
	trigger_next: $('[data-gallery-next]'),

	setupModal: function(slideId) {

		//console.log('gallery: setupModal');
		var slide_ammount = $('[data-gallery-index]').length;
		var trigger = $('[data-gallery-index="' + slideId + '"]');
		var content = trigger.find('.gallery-content');
		var copy = content.children().clone();
		var imgUrl = content.data('gallery-image-large');

		gallery.content_hideShow(slide_ammount, slideId, copy, imgUrl);
	},

	content_hideShow: function(slide_ammount, slideId, copy, imgUrl) {
	//	console.log('gallery: content_hideShow');

		if ( $(gallery.modal).hasClass('in') ) {
			$(gallery.modal).find('.modal-gallery-content-inner').removeClass( "ellipsis-new" );
			var fadeOut_items = $(gallery.modal).find('.modal-gallery-content-inner').children('h3, p').add('.modal-gallery-image-wrapper img');
			fadeOut_items.animate({'opacity': 0}, 300, function(){
				console.log('gallery: fadeOut');
				gallery.content_populate(slide_ammount, slideId, copy, imgUrl);
			});

		} else {

			gallery.content_populate(slide_ammount, slideId, copy, imgUrl);
		}
	},

	content_populate: function(slide_ammount, slideId, copy, imgUrl) {

		console.log( 'gallery: content_populate populate slide ' + slideId + '/' + slide_ammount );
		// Setup prev/next arrows
		var prevNext = gallery.getPrevNext(slide_ammount, slideId);
		gallery.trigger_prev.attr( 'data-gallery-nav', prevNext[0] );
		gallery.trigger_next.attr( 'data-gallery-nav', prevNext[1] );
		// Set counter text
		gallery.counter.empty().html(slideId + '<span>/</span>' + slide_ammount);
		// Clean possible previous content
		gallery.content_inner.find('>*:not(div)').remove();
		//remove all instances of the ellipsis class and add them again
		gallery.content_inner.find('.ellipsis-new').remove();
		// Insert content
		copy.insertBefore(gallery.prevNext_wrapper);

		// Insert image
		gallery.image.attr('src', imgUrl);

	},
	// Set slide numbers to prev/next navigation
	getPrevNext: function(slide_ammount, slideId) {
		var slide_ammount = parseInt(slide_ammount);
		var slideId = parseInt(slideId);

		var prev = slideId - 1;
		var next = slideId + 1;

		if (prev == 0)
			prev = slide_ammount;

		if (next > slide_ammount)
			next = 1;

		return [prev, next];
	},

	checkImgLoad: function() {
		gallery.image.on('load', function(){
			console.log('gallery: image loaded');
			var _this = $(this);
			if (_this.width() > _this.height()){
				_this.removeAttr('class').addClass('image-landscape');
			} else {
				_this.removeAttr('class').addClass('image-portrait');
			}
			if ( $(gallery.modal).hasClass('in') ) {
				console.log('gallery: fadeIn');
				var fadeIn_items = $(gallery.modal).find('.modal-gallery-content-inner').children('h3, p').add('.modal-gallery-image-wrapper img');
				fadeIn_items.animate({'opacity': 1}, 300);
			} else {
				modal.show( gallery.modal );
			}
			var ellipsisEl = gallery.content_inner.find('.ellipsis-new');
			ellipsisNew.applyEllipsis(ellipsisEl);
		});
	},

	navigateSlide: function() {
		$('[data-gallery-nav]').on('click', function(){
			console.log('gallery: nav clicked');
			var slideId = $(this).attr('data-gallery-nav');
			console.log('navigate to: ' + slideId);
			gallery.setupModal( slideId );
		});
	},

	init: function() {
		if ($(gallery.modal).length) {
			console.log('gallery init')
			gallery.navigateSlide();
			gallery.checkImgLoad();

		}
	}
};
